module.exports = __webpack_public_path__ + "img/DM.e791b00f.svg";